<template>
  <div>
    <!--Header Components-->
    <base-header class="pb-6" type="">
      <b-row class="align-items-center py-4">
        <b-col lg="6" cols="7">
          <!-- <h6 class="h2 text-white d-inline-block mb-0">{{$route.name}}</h6> -->
          <h6 class="h2 d-inline-block mb-0">{{ language_terms[$route.name] }}</h6>
          <nav aria-label="breadcrumb" class="d-none d-md-inline-block ml-md-4">
            <route-breadcrumb />
          </nav>
        </b-col>
      </b-row>
    </base-header>
    <!--contents-->
    <b-container fluid class="mt--6 container-padding">
      <b-row>
        <div>
            <loading :active.sync="loading" 
                color= '#007bff'
                :width= '128'
                :height= '128'
                loader='dots'
                :can-cancel="true" 
                :is-full-page="true">
            </loading>
        </div>
        <b-col lg="12">
          <div class="card-wrapper">
            <b-card no-body>
              <b-tabs pills card>
                <!--Basic information Tab-->
                <b-tab title="Main" active>
                  <b-card-text>
                    <card>
                      <div slot="header">
                        <b-row>
                          <b-col lg="6">
                              <h3>{{language_terms['BASIC_INFORMATION']}} 
                                  <span v-if="employee.code">({{employee.code}})</span>
                              </h3>
                          </b-col>
                        </b-row>
                      </div>
                      <b-row>
                        <b-col md="2">
                          <base-input :label="language_terms['CODE']" v-model="employee.code" :disabled="disabled"></base-input>
                        </b-col>
                        <b-col md="8">
                          <base-input :label="language_terms['NAME']" v-model="employee.name" :disabled="disabled"></base-input>
                        </b-col>
                        <b-col md="2">
                          <base-input label="Date Joined" type = "date" v-model="employee.date_joined" :disabled="disabled"></base-input>
                        </b-col>
                      </b-row>
                      <b-row>
                        <b-col cols="3">
                          <base-input
                            :disabled="disabled"
                            :label="language_terms['NRIC']"
                            v-model="employee.uen"
                          ></base-input>
                        </b-col>                        
                        <b-col cols="3">
                          <base-input
                            :disabled="disabled"
                            :label="language_terms['MOBILE']"
                            v-model="employee.contact_mobile"
                          ></base-input>
                        </b-col>                        
                        <b-col cols="3">
                          <base-input
                            :disabled="disabled"
                            :label="language_terms['EMAIL']"
                            v-model="employee.contact_email"
                          ></base-input>
                        </b-col>
                        <b-col cols="3">
                          <base-input
                            :disabled="disabled"
                            :label="language_terms['TELEPHONE']"
                            v-model="employee.contact_telephone"
                          ></base-input>
                        </b-col>
                      </b-row>
                      <b-row>
                        <b-col md="12">
                            <base-input :label="language_terms['REMARKS']">
                                <textarea
                                class="form-control"
                                id="exampleFormControlTextarea1"
                                rows="10"
                                v-model="employee.remarks"
                                :disabled="disabled">
                                </textarea>
                            </base-input>
                        </b-col>

                        <!-- <b-col cols="3" v-for = "(meta, i) in employee.metas" :key="i">
                            <label class="form-control-label" v-if="meta.key == 'whatsapp'">{{language_terms["WHATSAPP_MOBILE"]}}</label>
                            <label class="form-control-label" v-if="meta.key == 'facebook'">{{language_terms["FACEBOOK"]}}</label>
                            <base-input :disabled="disabled" v-model="meta.value"></base-input>
                        </b-col> -->
                      </b-row>                         
                    </card>
                    <card v-if="0">
                      <h3 slot="header">
                        {{ language_terms["CONTACT_INFO"] }}
                      </h3>
                      <b-row>
                        <b-col cols="4">
                          <base-input
                            :disabled="disabled"
                            :label="language_terms['MOBILE']"
                            v-model="employee.contact_mobile"
                          ></base-input>
                        </b-col>                        
                        <b-col cols="4">
                          <base-input
                            :disabled="disabled"
                            :label="language_terms['EMAIL']"
                            v-model="employee.contact_email"
                          ></base-input>
                        </b-col>
                        <b-col cols="4">
                          <base-input
                            :disabled="disabled"
                            :label="language_terms['TELEPHONE']"
                            v-model="employee.contact_telephone"
                          ></base-input>
                        </b-col>
                      </b-row>
                      <b-row>
                        <b-col md="12">
                            <base-input :label="language_terms['REMARKS']">
                                <textarea
                                class="form-control"
                                id="exampleFormControlTextarea1"
                                rows="5"
                                v-model="employee.remarks"
                                :disabled="disabled">
                                </textarea>
                            </base-input>
                        </b-col>

                        <!-- <b-col cols="3" v-for = "(meta, i) in employee.metas" :key="i">
                            <label class="form-control-label" v-if="meta.key == 'whatsapp'">{{language_terms["WHATSAPP_MOBILE"]}}</label>
                            <label class="form-control-label" v-if="meta.key == 'facebook'">{{language_terms["FACEBOOK"]}}</label>
                            <base-input :disabled="disabled" v-model="meta.value"></base-input>
                        </b-col> -->
                      </b-row>                      
                    </card>
                    <b-card v-if="0">
                      <h3 slot="header">
                        {{ language_terms["OTHERS"] }}
                      </h3>
                    </b-card>
                  </b-card-text>
                  <div class="floating-bar">
                     <div class="floating-bar-container" align="center">
                       <b-button-group>
                          <b-button class="transparent-btn"  @click="editContact" v-if="disabled">
                             <i class="fas fa-edit mr-2 text-primary"></i>{{language_terms['EDIT']}}
                          </b-button>
                          <b-button class="transparent-btn"  @click="save" v-if="!disabled">
                             <i class="fas fa-save mr-2 text-info"></i>{{language_terms['SAVE']}}
                          </b-button>
                          <b-button class="transparent-btn"  @click="cancel" v-if="!disabled">
                             <i class="fa fa-times mr-2 text-warning"></i>{{language_terms['CANCEL']}}
                          </b-button>
                          <b-button class="transparent-btn" @click="deleteContact" v-if="$route.params.id != '_new'">
                             <i class="fas fa-trash mr-2 text-danger"></i>{{language_terms['DELETE']}}
                          </b-button>
                       </b-button-group>
                     </div>
                  </div>
                </b-tab>


                <b-tab title="Transactions" v-if="show_unit_tab">
                  <card>
                    <b-form @submit.prevent="addTransaction" class="mb-2"> <!-- Added margin bottom -->
                      <b-row>
                        <b-col cols="12" md="2">
                          <b-form-group label="Date" label-for="transaction-date" >
                            <b-form-input
                              id="transaction-date"
                              v-model="transaction.date"
                              type="date"
                              required
 
                            ></b-form-input>
                          </b-form-group>
                        </b-col>

                        <b-col md="2">
                          <b-form-group label="Type" label-for="transaction-type">
                            <b-form-select
                              id="transaction-type"
                              v-model="transaction.type"
                              :options="transactionTypes"
                              required
                            ></b-form-select>
                          </b-form-group>
                        </b-col>                        
                        <b-col cols="12" md="2">

                          <b-form-group label="Amount">
                            <b-form-input 
                              v-model="transaction.amount"
                              @blur="formatNumberInput('amount', transaction)" 
                              type="text"
                            ></b-form-input>
                          </b-form-group>
<!-- 
                          <b-form-group label="Amount" label-for="transaction-amount" >
                            <b-form-input
                              id="transaction-amount"
                              v-model="transaction.amount"
                              type="number"
                              step="0.01"
                              required
 
                            ></b-form-input>
                          </b-form-group> -->
                        </b-col>

                        <b-col cols="12" md="2">
                          <b-form-group label="Reference" label-for="transaction-reference1" >
                            <b-form-input
                              id="transaction-reference1"
                              v-model="transaction.reference" 
                            ></b-form-input>
                          </b-form-group>
                        </b-col>

                        <b-col cols="12" md="3">
                          <b-form-group label="Remarks" label-for="transaction-remarks" >
                            <b-form-input
                              id="transaction-remarks"
                              v-model="transaction.remarks" 
                            ></b-form-input>
                          </b-form-group>
                        </b-col>

                        <b-col cols="12" md="1">
                          <b-form-group label="" class="mt-4">
                            <b-button class="mt-2" type="submit" variant="primary">Add</b-button>
                          </b-form-group>
                        </b-col>

                        <b-col cols="12" md="3">
                          <b-form-group label="Balance" label-for="transaction-balance" >
                            <b-form-input
                              id="transaction-balance"
                              v-model="employee.summary.transactions.amount"
                              disabled
                            ></b-form-input>
                          </b-form-group>
                        </b-col>          
                        <b-col cols="12" md="3">
                          <b-form-group label="Total Credit" label-for="transaction-balance" >
                            <b-form-input
                              id="transaction-balance"
                              v-model="employee.summary.transactions.total_credit"
                              disabled 
                            ></b-form-input>
                          </b-form-group>
                        </b-col>   
                        <b-col cols="12" md="3">
                          <b-form-group label="Total Debit" label-for="transaction-balance" >
                            <b-form-input
                              id="transaction-balance"
                              v-model="employee.summary.transactions.total_debit"
                              disabled 
                            ></b-form-input>
                          </b-form-group>
                        </b-col>                                                                 
                      </b-row>

                      
                    </b-form>

                    <b-table striped hover v-if="employee.transactions.length > 0"
                      :items="employee.transactions"
                      :fields="transactionFields"
                      responsive="sm"
                    >
                      <!-- You can add slot templates for custom rendering if needed -->
                    </b-table>
                  </card>
                </b-tab>
                
                <b-tab title="Configuration" v-if="show_unit_tab">
                  <card>
                    <!-- Add Meta Key/Value Inputs and Add Button -->
                    <b-row>
                      <b-col md="3">
                        <b-form-group label="Key" md="3">
                          <b-form-select v-model="meta.key" :options="metaKeyOptions" />
                        </b-form-group>                      
                      </b-col>
                      <b-col md="8">
                        <base-input label="Value" v-model="meta.value"/>
                      </b-col>

                      <b-col cols="12" md="1" class="mt-2">
                        <base-button type="success" @click="onClickAddMeta" class="float-left mt-4" size="md">
                          <i class="fa fa-plus"/>
                        </base-button>                    
                      </b-col>
                    </b-row>

                    <!-- Meta Values Table with Delete Buttons -->
                    <b-table striped hover :items="employee.metas" :fields="metaFields" responsive="sm" v-if="employee.metas.length > 0">
                    <!-- Key, Value, and Time Created Columns -->
                    <template #cell(timeCreated)="data">
                      {{ formatDate(data.item.timeCreated) }}
                    </template>

                    <!-- Delete Button Column -->
                    <template #cell(actions)="data">
                      <b-button variant="danger" size="sm" @click="deleteMeta(data.item.id, data.index)">
                        Delete
                      </b-button>
                    </template>
                  </b-table>
                  </card>
                </b-tab>
              
              </b-tabs>
            </b-card>
          </div>
        </b-col>
      </b-row>
    </b-container>
  </div>
</template>
<style src="vue-multiselect/dist/vue-multiselect.min.css"></style>
<script>
import flatPicker from "vue-flatpickr-component";
import moment from "moment";
import axios from "axios";
import { apiBaseUrl } from '../../apiRoutes';
import { apiRoutes } from '../../apiRoutes';
import { authHeader } from '../../global';

import priceSetup from '../Components/priceSetup.vue';

import Collapse from "@/components/Collapse/Collapse";
import CollapseItem from "@/components/Collapse/CollapseItem";
import { mapState } from "vuex";
import { Select, Option } from "element-ui";
import bankAccounts from "../Components/bankAccounts.vue";
import Loading from 'vue-loading-overlay';
import 'vue-loading-overlay/dist/vue-loading.css';

export default {
  data() {
    return {
      transactionFields: [
        { key: 'date', label: 'Date' },
        { key: 'type', label: 'Type' },
        { key: 'amount', label: 'Amount' },
        { key: 'reference', label: 'Reference' },
        { key: 'remarks', label: 'Remarks' }
      ],      
      transactionTypes: [
        { value: null, text: 'Select Type' }, // Placeholder
        { value: 'PAYOUT', text: 'PAYOUT' },
        { value: 'PENALTY', text: 'PENALTY' },
        { value: 'FINE', text: 'FINE' },
        { value: 'CREDIT SALARY', text: 'CREDIT SALARY' },
        { value: 'CREDIT JOB', text: 'CREDIT JOB' },
        // Add more types as needed
      ],
      aa:null,
      transaction: {
        date: null,
        type: null,
        amount: 0,
        reference: null,
        reference2: null,
        reference3: null,
        remarks: null,
      },
      metaKeyOptions: [
        { value: 'PACKAGE', text: 'PACKAGE' },
        { value: 'CAINIAO USER', text: 'CAINIAO USER' },
        { value: 'PAYNOW', text: 'PAYNOW' },
        
      ],  
      meta:{
        key:null,
        value:null,
      },
      is_edit:false,
      disabled:true,
      loading:false,
      addUnitModal: false,
      show_unit_tab: false,
      headerBgVariant: "primary",
      headerTextVariant: "light",
      bank_accounts:[],
      employee: {
        uen:null,
        contact_categories:[],
        name: "",
        country_code: "",
        currency_code: "",
        customer_credit_limit: "",
        customer_credit_term: "",
        address_street: "",
        address_district: "",
        address_city: "",
        address_district: "",
        address_postcode: "",
        address_country_code: "",
        contact_person: "",
        contact_mobile: "",
        contact_telephone: "",
        contact_telephone: "",
        contact_fax: "",
        contact_email: "",
        remarks: "",
        transactions:[],
        summary:{
          transactions:
          {total_credit:0, total_debit:0, amount:0},
        },
        date_joined:null
      },
      options: ["list", "of", "options"],
    };
  },
  components: {
    flatPicker,
    Loading,
    Collapse,
    CollapseItem,
    [Select.name]: Select,
    [Option.name]: Option,
    priceSetup
  },
  computed: {
    metaFields() {
      return [
        { key: 'key', label: 'Key' },
        { key: 'value', label: 'Value' },
        { key: 'time_created', label: 'Time Created' },
        { key: 'actions', label: 'Actions' },
      ];
    },
    ...mapState({
      salesperson_list:state => state.employees.salesperson_list,
      filter: (state) => state.customers.filter,
      currencies: (state) => state.currencies.currencies,
      taxes: (state) => state.taxes.taxes,
      countries: (state) => state.countries.countries,
      employee_data: (state) => state.employees.data,
      language_terms: (state) => state.languages.language_terms,
      selected_lang: (state) => state.languages.selected_langauge,
      employee_is_created: (state) => state.employees.is_created,
      employee_is_updated: (state) => state.employees.is_updated,
      is_deleted: (state) => state.employees.is_deleted,
      metas_config: (state) => state.employees.metas_config,
      contact_categories: (state) => state.contactCategories.active_list,
      debtor_accounts: (state) => state.employees.debtor_accounts

    }),
  },
  watch:{
      customer_data:
        {
            deep:true,
            handler(){
                this.employee = this.employee_data
            }
        }
    
  },
  async mounted() 
  {
     this.loading= true
      if (this.$route.params.id == "_new") 
      {
        this.show_unit_tab = false;
        this.disabled = false
        await this.$store.dispatch("employees/fetchMetaConfig", {})
        this.employee.metas = this.metas_config
      } 
      else 
      {
        await this.retrieveEmployee(this.$route.params.id);
        this.show_unit_tab = true;
        this.disabled = true

        this.formatNumberInput('total_debit', this.employee.summary.transactions);
        this.formatNumberInput('total_credit', this.employee.summary.transactions);
        this.formatNumberInput('amount', this.employee.summary.transactions);

      }
      this.transaction.date = moment().format("YYYY-MM-DD")

    this.loading = false
  },
  methods: {
    formatNumberInput(key, parent = null) {
      var rawValue = 0
      if (parent === null)
        rawValue = this[key].toString().replace(/,/g, ''); // Remove commas
      else
        rawValue = parent[key].toString().replace(/,/g, ''); // Remove commas

      const numberValue = parseFloat(rawValue) || 0; // Convert to number, default to 0

      // Update the transaction with the formatted number for display
      if (parent == null)
        this[key] = numberValue.toLocaleString(undefined, { minimumFractionDigits: 2, maximumFractionDigits: 2 });
      else
        parent[key] = numberValue.toLocaleString(undefined, { minimumFractionDigits: 2, maximumFractionDigits: 2 });    
    },
    async addTransaction() {
      if (this.transaction.type) {
        this.transaction.contact_id = this.employee.id
        let payload = this.transaction
        payload.amount = parseFloat(this.transaction.amount.replace(/,/g, ''))
        axios.post(apiBaseUrl + "employees/add-transaction", payload, authHeader()).then((response) => {
            if (response.data.code == 1) 
            {
              this.transaction.amount = null;
              this.transaction.reference = null;
              this.transaction.remarks = null;
              this.fetchTransactions();
            } 
        })
        .catch((error) => 
        {
            if (error.response) 
            {
                Vue.notify({group: "notify", type: "error", text: error.response.data.msg, max: 5, duration: 5000, speed: 300,});
            } 
        });
      }
    },
    async onClickAddMeta() {
      if (this.meta.key && this.meta.value) {
        this.meta.contact_id = this.employee.id
        let payload = this.meta
        axios.post(apiRoutes["EMPLOYEE_ADD_META"], payload, authHeader()).then((response) => {
            if (response.data.code == 1) 
            {
              this.meta.key = null;
              this.meta.value = null;
              this.fetchMetas();
            } 
        })
        .catch((error) => 
        {
            if (error.response) 
            {
                Vue.notify({group: "notify", type: "error", text: error.response.data.msg, max: 5, duration: 5000, speed: 300,});
            } 
        });
      }
    },
    async fetchTransactions()
    {
      this.transaction.contact_id = this.employee.id
      let payload = this.transaction
      axios.post(apiBaseUrl + "employees/retrieve-transactions", payload, authHeader()).then((response) => {
          if (response.data.code == 1) 
          {
            this.employee.summary.transactions = response.data.data.summary
            this.employee.transactions = response.data.data.details

            this.formatNumberInput('total_debit', this.employee.summary.transactions);
            this.formatNumberInput('total_credit', this.employee.summary.transactions);
            this.formatNumberInput('amount', this.employee.summary.transactions);
          } 
      })
      .catch((error) => 
      {
          if (error.response) 
          {
              Vue.notify({group: "notify", type: "error", text: error.response.data.msg, max: 5, duration: 5000, speed: 300,});
          } 
      });

    },
    async fetchMetas() {
      this.meta.contact_id = this.employee.id
      let payload = this.meta
      axios.post(apiRoutes["EMPLOYEE_RETRIEVE_METAS"], payload, authHeader()).then((response) => {
          if (response.data.code == 1) 
          {
            this.employee.metas = response.data.data
          } 
      })
      .catch((error) => 
      {
          if (error.response) 
          {
              Vue.notify({group: "notify", type: "error", text: error.response.data.msg, max: 5, duration: 5000, speed: 300,});
          } 
      });
    },
    // Method to delete a meta by index
    async deleteMeta(id, index) {
      let payload = {id:id}
      axios.post(apiRoutes["EMPLOYEE_DELETE_META"], payload, authHeader()).then((response) => {
          if (response.data.code == 1) 
          {
            this.employee.metas.splice(index, 1);
            Vue.notify({
              group: "notify",
              type: "success",
              text: 'Meta deleted successfully!',
            });
          } 
      })
      .catch((error) => 
      {
        if (error.response) 
        {
            Vue.notify({group: "notify", type: "error", text: error.response.data.msg, max: 5, duration: 5000, speed: 300,});
        } 
      });
    },  
    handleCollaspe(index, row)
    {
        if(row.is_collapsed)
        {
           row.is_collapsed = false
        }
        else
        {
          row.is_collapsed = true
        }

        console.log(row)

        this.$set(this.employee.units, index , row) 
    },
    editContact()
    {
      this.disabled =false
      this.is_edit= true
    },
    async deleteContact()
    {
        let response = await this.$confirm(this.language_terms['ARE_YOU_SURE_DELETE'] + '?', this.language_terms['CONFIRMATION'], {
                  confirmButtonText: this.language_terms['YES'],
                  cancelButtonText: this.language_terms['CANCEL'],
                  type: 'warning'
                }).catch(() => {
              this.$message.info(this.language_terms['ACTION_CANCEL'])
             })
        if (response === 'confirm') 
        {
            this.loading =true
            await this.$store.dispatch("employees/delete", this.employee);

            if(this.is_deleted)
            {
                await this.search();
                this.$router.push("/employees");
            }
           
            this.loading =false
        }
    },
    async retrieveEmployee(code) {
      this.loading =true
      await this.$store.dispatch("employees/fetch", {
        code: code,
      });

      console.log(this.employee)

      this.employee = this.employee_data;
      this.loading = false
    },
    addDepartment() {
      this.loading = true

      this.loading = false
    },
    async search()
    {
        this.loading = true
        let filter = {keyword:"",active_only:"1"}
        if(this.filter)
        {
            filter = this.filter
        }
        await this.$store.dispatch('employees/quickSearch', filter)

        this.loading = false
    },
    async save() {
      this.loading = true
      if (this.$route.params.id == "_new") 
      {
        await this.$store.dispatch("employees/create", this.employee);

        if(this.employee_is_created)
        {
          // refresh the store
          await this.search();
          this.$router.push("/employees");
        }
      } 
      else 
      {
        await this.$store.dispatch("employees/update", this.employee);
        if(this.employee_is_updated)
        {
          location.reload();
        }
      }
      this.loading = false
    },
    cancel() {
      if(this.$route.params.id == '_new')
        this.$router.push("/employees");
      else
        location.reload();
    },
  },
};
</script>
